import { Button } from '@getethos/ethos-design-system-v2'
import { cmsModuleAnalytics } from 'lib/@getethos/analytics/analyticsEvents'
import { mapQueryToUserData } from 'lib/@getethos/utils/mapQueryToUserData'
import { getQueryString } from 'lib/@getethos/utils/utils'
import { transmitRiskToken } from 'lib/TransmitSecurity/riskToken'
import { isEmpty } from 'lodash'

import useDetectScreenSize from '@/hooks/useDetectScreenSize'
import { useNavigateToApp } from '@/hooks/useNavigateToApp'

import { HighlightProps } from '../Highlight'
import styles from './HighlightBrandRefresh.module.scss'

const CONSTANTS = {
  HEADLINE: 'Customized rates for any budget',
  SUBHEADLINE:
    'Choose a term and coverage amount to fit your needs. We’ll compare options across our multiple carriers to get you the lowest rate.',
  CTA: 'Check my price',
  VIDEO: {
    src: 'https://res.cloudinary.com/getethos/video/upload/v1753038777/25Q2_CustomizeCoverageAmount_TransparentBKGRD_WebM_zgq4eh.webm',
    title: 'Customize Coverage Amount',
  },
}

export const HighlightBrandRefresh = ({ moduleData }: HighlightProps) => {
  const { isLaptopAndUp } = useDetectScreenSize()
  const { handleNavigateToApp } = useNavigateToApp()
  const { clickthroughUrl } = moduleData

  const queryParameters = getQueryString()
  const queryParamData = mapQueryToUserData(queryParameters || {})
  const userData = isEmpty(queryParamData) ? {} : queryParamData

  const handleCtaClicked = () => {
    if (clickthroughUrl.includes('/app/')) {
      transmitRiskToken()
    }
    cmsModuleAnalytics.ctaClicked({
      properties: {
        ctaLabel: CONSTANTS.CTA,
        clickthroughUrl,
        module: 'Highlight',
      },
    })
    handleNavigateToApp(userData, false, false, false, clickthroughUrl)
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h3 className={styles.headline}>{CONSTANTS.HEADLINE}</h3>
          <p className={styles.subHeadline}>{CONSTANTS.SUBHEADLINE}</p>
          {isLaptopAndUp && (
            <Button
              className={styles.cta}
              buttonTitle={CONSTANTS.CTA}
              variant="primary"
              size="md"
              onClick={handleCtaClicked}
            />
          )}
        </div>
        <div>
          <video
            className={styles.video}
            muted
            id={CONSTANTS.VIDEO.title}
            loop
            playsInline
            autoPlay
            preload="auto"
          >
            <source src={CONSTANTS.VIDEO.src} type="video/webm" />
          </video>
          {!isLaptopAndUp && (
            <Button
              className={styles.cta}
              buttonTitle={CONSTANTS.CTA}
              variant="primary"
              size="md"
              onClick={handleCtaClicked}
            />
          )}
        </div>
      </div>
    </section>
  )
}
